import React from "react";
import Flag from "react-world-flags";
import { getStatusIcon } from "../dummy-data/statuses";

export default function TopLeftDetails({ userData }) {
	return (
		<div className="position-absolute top-0 start-0 m-2 mt-1">
			{userData?.nationality && (
				<div className="d-flex align-items-center">
					<Flag code={userData?.nationality.code || ""} style={{ width: "30px", height: "20px" }} className="me-2" />
					<span>{userData?.nationality.name}</span>
				</div>
			)}

			{userData.status && (
				<div className="d-flex align-items-center">
					{getStatusIcon(userData.status)}
					<span className="ms-2">{userData.status}</span>
				</div>
			)}

			{userData.profession && (
				<div className="d-flex align-items-center">
					<i className={`bi ${userData.profession.icon} me-2`}></i>
					<span>{userData.profession.name}</span>
				</div>
			)}
		</div>
	);
}
